import { useState, useEffect } from 'react';
import { detectWebView, openInExternalBrowser } from '@/utils/webview';

export function WebViewBanner() {
  const [show, setShow] = useState(false);
  const { isWebView } = detectWebView();

  useEffect(() => {
    // WebView이고 이전에 닫지 않았으면 표시
    if (isWebView && !sessionStorage.getItem('hide-webview-banner')) {
      setShow(true);
    }
  }, [isWebView]);

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '60px',  // 헤더 아래
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 999,
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      color: 'white',
      padding: '8px 12px 8px 16px',
      borderRadius: '24px',
      fontSize: '13px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.3)',
      animation: 'fadeIn 0.3s ease-out',
      whiteSpace: 'nowrap',  // 줄바꿈 방지
      maxWidth: '90%'  // 작은 화면 대응
    }}>
      <span style={{ fontSize: '13px', flexShrink: 0 }}>🌐</span>
      <span style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>브라우저로 열기</span>
      
      <button
        onClick={() => {
          openInExternalBrowser();
          setShow(false);
          sessionStorage.setItem('hide-webview-banner', 'true');
        }}
        style={{
          padding: '4px 12px',
          backgroundColor: '#FF6D00',
          color: 'white',
          fontSize: '12px',
          fontWeight: '600',
          border: 'none',
          borderRadius: '16px',
          cursor: 'pointer',
          flexShrink: 0,  // 버튼 크기 유지
          whiteSpace: 'nowrap'  // 버튼 텍스트도 줄바꿈 방지
        }}
      >
        열기
      </button>
      
      <button
        onClick={() => {
          setShow(false);
          sessionStorage.setItem('hide-webview-banner', 'true');
        }}
        style={{
          width: '20px',
          height: '20px',
          padding: 0,
          backgroundColor: 'transparent',
          border: 'none',
          color: '#999',
          fontSize: '16px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0  // 닫기 버튼 크기 유지
        }}
        aria-label="닫기"
      >
        ×
      </button>
    </div>
  );
}